import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import Login from './pages/Login'

// Admin pages
import Allergens from './pages/admin/Allergens'
import Units from './pages/admin/Units'
import Suppliers from './pages/admin/Suppliers'
import Ingredients from './pages/Ingredients'
import Users from './pages/Users'
import PrintTemplates from './pages/admin/PrintTemplates'
import Printers from './pages/admin/Printers'

// Purchase pages
import PurchaseOrders from './pages/purchases/PurchaseOrders'
import Receiving from './pages/purchases/Receiving'

// Main modules
import Inventory from './pages/Inventory'
import InventoryBatchDetail from './pages/InventoryBatchDetail'
import InventoryByIngredient from './pages/InventoryByIngredient'
import Recipes from './pages/Recipes'
import Production from './pages/Production'
import Shipments from './pages/shipments/Shipments'
import HACCP from './pages/HACCP'
import Reports from './pages/Reports'
import Traceability from './pages/Traceability'

import { AuthProvider } from './contexts/AuthContext'
import { ToastProvider } from './contexts/ToastContext'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ToastProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Layout />}>
              <Route index element={<Dashboard />} />

              {/* Admin Routes */}
              <Route path="admin/allergens" element={<Allergens />} />
              <Route path="admin/units" element={<Units />} />
              <Route path="admin/suppliers" element={<Suppliers />} />
              <Route path="admin/ingredients" element={<Ingredients />} />
              <Route path="admin/users" element={<Users />} />
              <Route path="admin/print-templates" element={<PrintTemplates />} />
              <Route path="admin/printers" element={<Printers />} />

              {/* Purchase Routes */}
              <Route path="purchases/orders" element={<PurchaseOrders />} />
              <Route path="purchases/receiving" element={<Receiving />} />

              {/* Main Routes */}
              <Route path="inventory" element={<Inventory />} />
              <Route path="inventory/:id" element={<InventoryBatchDetail />} />
              <Route path="inventory-by-ingredient" element={<InventoryByIngredient />} />
              <Route path="recipes" element={<Recipes />} />
              <Route path="production/*" element={<Production />} />
              <Route path="shipments" element={<Shipments />} />
              <Route path="haccp/*" element={<HACCP />} />
              <Route path="traceability" element={<Traceability />} />
              <Route path="reports" element={<Reports />} />
            </Route>
          </Routes>
        </Router>
        </ToastProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
}

export default App